import CityLandingPage from './CityLandingPage';
import { cityPages } from '@/mocks/cityPages';

const data = cityPages.find((c) => c.slug === 'electronics-recycling-pasadena')!;
const PasadenaPage = () => <CityLandingPage data={data} />;
export default PasadenaPage;
